var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMatchingLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      background: "transparent",
      display: "block"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ldio-w6sbh0ri24b-filter",
    x: "-100%",
    y: "-100%",
    width: "300%",
    height: "300%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 2.4000000000000004
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    result: "cutoff"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "table",
    tableValues: "0 0 0 0 0 0 1 1 1 1 1"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ldio-w6sbh0ri24b-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 0,
    r: 5,
    fill: "#FBD207"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    keyTimes: "0;0.5;1",
    values: "3.5999999999999996;8.399999999999999;3.5999999999999996",
    dur: "4s",
    repeatCount: "indefinite",
    begin: "-0.25s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    keyTimes: "0;1",
    values: "0;360",
    dur: "4s",
    repeatCount: "indefinite",
    begin: "0s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 0,
    r: 5,
    fill: "#FBD207"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    keyTimes: "0;0.5;1",
    values: "3.5999999999999996;8.399999999999999;3.5999999999999996",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-0.2s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    keyTimes: "0;1",
    values: "0;360",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-0.05s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 0,
    r: 5,
    fill: "#00A3E0"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    keyTimes: "0;0.5;1",
    values: "3.5999999999999996;8.399999999999999;3.5999999999999996",
    dur: "1.3333333333333333s",
    repeatCount: "indefinite",
    begin: "-0.15s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    keyTimes: "0;1",
    values: "0;360",
    dur: "1.3333333333333333s",
    repeatCount: "indefinite",
    begin: "-0.1s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 0,
    r: 5,
    fill: "#FBD207"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    keyTimes: "0;0.5;1",
    values: "3.5999999999999996;8.399999999999999;3.5999999999999996",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.1s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    keyTimes: "0;1",
    values: "0;360",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.15s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 0,
    r: 5,
    fill: "#FBD207"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    keyTimes: "0;0.5;1",
    values: "3.5999999999999996;8.399999999999999;3.5999999999999996",
    dur: "0.8s",
    repeatCount: "indefinite",
    begin: "-0.05s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    keyTimes: "0;1",
    values: "0;360",
    dur: "0.8s",
    repeatCount: "indefinite",
    begin: "-0.2s"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchingLoader);
export default __webpack_public_path__ + "static/media/matching-loader.2ed54068.svg";
export { ForwardRef as ReactComponent };